import Contrato from '@/models/Contrato';
import Cosecha from '@/models/Cosecha';
import Grano from '@/models/Grano';
import Resumen from '@/models/Resumen';
import Total from '@/models/Total';

import axios from 'axios';
function defaultState() {
	return {
		totales: [],
		resumenes: [],
		granos: [],
		cosechas: [],
		items: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setCosechas(state: { cosechas: Cosecha[] }, data: Cosecha[]) {
		state.cosechas = data;
	},
	setTotales(state: { totales: Total[] }, data: Total[]) {
		state.totales = data;
	},
	setResumenes(state: { resumenes: Resumen[] }, data: Resumen[]) {
		state.resumenes = data;
	},
	setItems(state: { items: Contrato[] }, data: Contrato[] | Contrato) {
		!Array.isArray(data) ? state.items.push(data) : (state.items = []);
	},
	setGranos(state: { granos: Grano[] }, granos: Grano[]) {
		state.granos = granos;
	},
};
const actions = {
	/**
	 * LLama al cgi etenet_contratos
	 * @param params contiene data los filtros de la busqueda start y limit para el paginado
	 * @returns array de tipo Contratos
	 */
	async callResumenContratos({ commit }, params: { data: object; start: number; limit: number }): Promise<Contrato[]> {
		const response = await axios.get(`./api/public/proxy/cgi/etenet_contratos?start=${params.start}&limit=${params.limit}`, params.data);
		if (response.data.items) {
			response.data.items.forEach((element: Contrato) => {
				commit('setItems', element);
			});
		}

		commit('setResumenes', response.data.resumenes as Resumen[]);
		commit('setGranos', response.data.granos as Grano[]);
		commit('setCosechas', response.data.cosechas as Cosecha[]);
		if (response.data.totales) commit('setTotales', response.data.totales[0] as Total);

		return response.data.items;
	},
	async downloadFileContratos(
		{ commit, dispatch },
		params: {
			recordSelected: {
				codcom1: number;
				codcom2: number;
				codtal1: number;
				codtal2: number;
				numero1: number;
				numero2: number;
			};
			num: number;
		}
	): Promise<Contrato> {
		//var recordSelected = params.recordSelected;
		const codcom = params.num === 1 ? this.recordSelected.codcom1 : this.recordSelected.codcom2;
		const codtal = params.num === 1 ? this.recordSelected.codtal1 : this.recordSelected.codtal2;
		const numero = params.num === 1 ? this.recordSelected.numero1 : this.recordSelected.numero2;
		const response = await axios.get(`./api/public/proxy/imprime?codcom=${codcom}&codtal=${codtal}&numero=${numero}`);
		return response.data;
	},
	/**
	 * Limpia, carga con un array vacio al arreglo de contratos.
	 */
	resetItems({ commit }): void {
		let empty: Contrato[] = [];
		commit('setItems', empty);
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
